export const ALL_KEY_PERSONS = {
  label: 'All key persons',
  value: null,
}
